/**
 * Copyright (C) SaigonMD, Inc - All Rights Reserved
 * Licensed under the MIT license.
 * Written by Tran Quan <tranquan221b@gmail.com>, July 2018
 */
/**
 * Log helper using Reactotron https://github.com/infinitered/reactotron
 * - log faster than console because no need to turn-on remote debug
 * - able to customize the message
 */
import Reactotron, { trackGlobalErrors } from 'reactotron-react-js'

export class LogConfig {
  public static configure = (enabled: boolean) => {
    if (enabled) {
      LogConfig.configureReactotron()
      LogConfig.connectConsoleToReactotron()
    }
  }

  private static info = (message: string, ...args: any[]) => {
    Reactotron.display({
      name: 'INFO',
      preview: message,
      value: { message, args },
    })
  }

  private static warn = (message: string, ...args: any[]) => {
    Reactotron.display({
      important: true,
      name: 'WARN',
      preview: message,
      value: { message, args },
    })
  }

  private static error = (message: string, ...args: any[]) => {
    Reactotron.display({
      important: true,
      name: 'ERROR',
      preview: message,
      value: { message, args },
    })
  }

  private static configureReactotron = () => {
    Reactotron.configure({
      name: 'App',
    })
      .use(trackGlobalErrors({}))
      .connect()

    // clear log on start
    if (Reactotron.clear) {
      Reactotron.clear()
    }
  }

  private static connectConsoleToReactotron = () => {
    // tslint:disable
    console.info = LogConfig.info
    console.log = LogConfig.log
    console.warn = LogConfig.warn
    console.error = LogConfig.error
    // tslint:enable
  }

  private static log = (message: string, ...args: any[]) => {
    Reactotron.display({
      name: 'LOG',
      preview: message,
      value: { message, args },
    })
  }
}

export default LogConfig
